import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';

import { collectFormValidationErrors } from './formFieldUtils';

function hasValidationContent({ flatErrors, customMessages }) {
  return flatErrors.length > 0 || (customMessages?.length ?? 0) > 0;
}

const FormValidationSummary = ({
  show,
  errors = {},
  excludeFields = [],
  fieldLabels = {},
  fieldLabelResolver,
  customMessages = [],
  title = '驗證錯誤：',
  className,
}) => {
  const flatErrors = useMemo(
    () => collectFormValidationErrors(errors, {
      excludeFields,
      fieldLabels,
      fieldLabelResolver,
    }),
    [errors, excludeFields, fieldLabels, fieldLabelResolver],
  );

  const customList = customMessages || [];
  const customTextSet = new Set(customList);
  // applyManualIssues 會同時 setError＋customMessages，避免總提示重複列
  const uniqueFlatErrors = flatErrors.filter((item) => !customTextSet.has(item.text));
  const hasContent = hasValidationContent({
    flatErrors: uniqueFlatErrors,
    customMessages: customList,
  });
  const shouldShow = show === undefined ? hasContent : (Boolean(show) && hasContent);

  if (!shouldShow) {
    return null;
  }

  return (
    <div
      className={cn(
        'form-validation-summary mb-4 p-2.5 text-red-500 bg-red-50 border border-red-200 rounded-md',
        className,
      )}
      role="alert"
    >
      <p className="mb-2 font-bold">{title}</p>
      <ul className="ml-4 list-disc space-y-2 text-sm">
        {uniqueFlatErrors.map((item) => (
          <li key={item.key} className="ml-2">
            {item.text}
          </li>
        ))}
        {customList.map((msg, index) => (
          <li key={`custom-${index}`} className="ml-2">
            {msg}
          </li>
        ))}
      </ul>
    </div>
  );
};

FormValidationSummary.propTypes = {
  show: PropTypes.bool,
  errors: PropTypes.object,
  excludeFields: PropTypes.arrayOf(PropTypes.string),
  fieldLabels: PropTypes.object,
  fieldLabelResolver: PropTypes.func,
  customMessages: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  className: PropTypes.string,
};

export default FormValidationSummary;
